import React from 'react';
import ProfileCard from './components/ProfileCard/ProfileCard';
import './App.css';
import fotoPerfil from './assets/images/profile.jpg';

function App() {
  // Dados do perfil - você pode mover isso para um arquivo separado ou usar props
  const profileData = {
    name: "Leow Rznd Kmpk",
    title: "Programador & Tatuador",
    description: "Desenvolvedor de sites Front-End (Wordpres, React) e Artista de Tatuagem. Criando experiências digitais e arte corporal única. Residente em",
    city: "Taboão da Serra",
    email: "contato@leow.com.br",
    phone: "",
    photo: fotoPerfil, // Adicione o caminho da sua foto aqui: "/assets/images/profile.jpg"
    socialLinks: {
      github: "https://github.com/mrleowRezende",
      instagram: "https://www.instagram.com/leow.br/",
      linkedin: "https://www.linkedin.com/in/leonardo-rezende-kempka-24832b174/",
      facebook: "https://www.facebook.com/leonardo.rezendeoliveira/"
    }
  };

  return (
    <div className="App">
      <ProfileCard data={profileData} />
    </div>
  );
}

export default App;